import React from 'react';
import './Testimonial.css';
import { testimonialsData } from '../../data/testimonialsData.js';
import { motion } from 'framer-motion';
import leftArrow from '../../assets/leftArrow.png';
import rightArrow from '../../assets/rightArrow.png';
const Testimonial = () => {
    const [selected, setSelected] = React.useState(0);
    const tLength = testimonialsData.length;
    const transition = { type: "spring", duration: 1 };
    return (
        <div className="Testimonial" id='Testimonial'>
            <div className="left-t">
                <span>Testimonial</span>
                <span className='stroke-text'>what they</span>
                <span>say about us</span>
                <motion.span
                    key={selected}
                    initial={{ opacity: 0, x: -100 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: 100 }}
                    transition={transition}>{testimonialsData[selected].review}</motion.span>
                <span>
                    <span style={{ color: "var(--orange)" }}>
                        {testimonialsData[selected].name}
                    </span>{" "}
                    - {testimonialsData[selected].status}
                </span>
            </div>
            <div className="right-t">
                <motion.div
                    initial={{ opacity: 0, x: -100 }}
                    transition={{ ...transition, duration: 2 }}
                    whileInView={{ opacity: 1, x: 0 }}
                ></motion.div>
                <motion.div
                    initial={{ opacity: 0, x: -100 }}
                    transition={{ ...transition, duration: 2 }}
                    whileInView={{ opacity: 1, x: 0 }}
                ></motion.div>
                <motion.img
                    key={selected}
                    initial={{ opacity: 0, x: 100 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -100 }}
                    transition={transition}
                    src={testimonialsData[selected].image}
                    alt=""
                />
                <div className="arrow-controls">
                    <img
                        src={leftArrow}
                        alt=""
                        onClick={() => {
                            selected === 0
                                ? setSelected(tLength - 1)
                                : setSelected((prev) => prev - 1);
                        }}
                    />
                    {" "}
                    <img
                        src={rightArrow}
                        alt=""
                        onClick={() => {
                            selected === tLength - 1
                                ? setSelected(0)
                                : setSelected((prev) => prev + 1);
                        }}
                    />
                </div>
                {/* Example placeholder */}
                {/* <img src={testimonialsData[0].image} alt={testimonialsData[0].name} /> */}

            </div>
        </div>
    );
};

export default Testimonial;
